import { useQuery } from '@apollo/client';
import { PageContainer } from 'components/shared/Page/PageContainer';
import { CardContainer } from 'components/shared/CardContainer/CardContainer';
import { RenderWithFallback } from 'components/shared/Conditional/RenderWithFallback';
import { RenderWithCondition } from 'components/shared/Conditional/RenderWithCondition';
import { metabaseApi } from '../api';
import { MetaBaseDashboardResponse } from '../api/types';
import { MetabaseDashboardIds } from '../types';

export const DEV_MetabasePage = () => {
  const { data, loading } = useQuery<MetaBaseDashboardResponse, Record<'input', { dashboardId: number }>>(
    metabaseApi.metabaseDashboardIframeURL,
    { variables: { input: { dashboardId: MetabaseDashboardIds.Seventh } } }
  );

  return (
    <PageContainer>
      <CardContainer title="Metabase">
        <RenderWithFallback isLoading={loading} fallBack={<>Loading charts</>}>
          <RenderWithCondition condition={Boolean(data?.metaBaseDashboard?.success)} fallBack={<>Error</>}>
            <iframe
              width="100%"
              height="600"
              allowTransparency
              title="Metabase charts"
              style={{ border: 'none' }}
              src={data?.metaBaseDashboard.url!}
            />
          </RenderWithCondition>
        </RenderWithFallback>
      </CardContainer>
    </PageContainer>
  );
};
